import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { getInitials, TeamMember } from '../../types/team.types';

export type MemberAvatarProps = {
  className?: string;
  member: Pick<TeamMember, 'color' | 'name'>;
  size?: number;
};

// Consistent per-person badge: coloured circle + initials, used everywhere a member is shown.
export const MemberAvatar: FC<MemberAvatarProps> = ({ member, size = 28, className }) => (
  <div
    className={twMerge(
      'flex shrink-0 items-center justify-center rounded-full font-[550] leading-none text-white',
      className,
    )}
    style={{
      backgroundColor: member.color,
      fontSize: Math.max(9, Math.round(size * 0.38)),
      height: size,
      width: size,
    }}
    title={member.name}
  >
    {getInitials(member.name)}
  </div>
);
